import { usePathname } from "next/navigation";

export const useIsContractRequest = () => {
  const pathname = usePathname() as string | undefined;
  return pathname?.includes("/request") === true;
};
